/* eslint-disable */
//esimerkkifunktio
//import { testi } from './customfunctions';

//testi();

export default {
  //
}

/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/autoload/modules.js